import React from "react";
import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";
import { useHOH, STEP } from "../../../context/StyleContext";
import { OCCASIONS } from "../../../data/looks";
import StepFrame, { StepTitle } from "../StepFrame";

export default function OccasionStep() {
  const { occasion, setOccasion, goTo } = useHOH();
  return (
    <StepFrame wide>
      <StepTitle overline="Step 1" title="What are you preparing for?" subtitle="Choose the moment — every occasion gets its own signature style." />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
        {OCCASIONS.map((o, i) => {
          const selected = occasion === o.id;
          const Icon = o.icon;
          return (
            <motion.button
              key={o.id}
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.04 }}
              whileHover={{ y: -6 }}
              onClick={() => setOccasion(o.id)}
              data-testid={`occasion-${o.id.replace(/\s+/g, "-").toLowerCase()}`}
              className={`hoh-card relative p-6 flex flex-col items-center gap-3 text-center transition-all ${selected ? "hoh-glow-border" : ""}`}
              style={{ background: selected ? o.tint : "#fff" }}
            >
              {selected && <span className="absolute top-3 right-3 w-5 h-5 rounded-full bg-hoh-navy text-white flex items-center justify-center"><Check className="w-3 h-3" /></span>}
              <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: o.tint }}>
                <Icon className="w-6 h-6 text-hoh-rose" />
              </div>
              <span className="font-semibold text-black">{o.label}</span>
            </motion.button>
          );
        })}
      </div>
      <div className="mt-12 text-center min-h-[60px]">
        {occasion && (
          <motion.button initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
            onClick={() => goTo(STEP.UPLOAD)} className="btn-royal" data-testid="occasion-continue-btn">
            Continue <ArrowRight className="w-4 h-4" />
          </motion.button>
        )}
      </div>
    </StepFrame>
  );
}
